import { ITimeReport } from '~/types/models/timeReport';
import axiosBase from '~/utils/axios';

export type createTimeReportResponse = {
  result: ITimeReport;
  stoppedIds: string[];
  stopedTimeReports: ITimeReport[];
};

export default class TimeReportService {
  private static route: string = '/timeReports';

  public static getAll(jobCardId: string): Promise<ITimeReport[]> {
    return axiosBase.get(`${this.route}/${jobCardId}`).then(({ data }) => data);
  }

  public static create(payload: ITimeReport): Promise<createTimeReportResponse> {
    return axiosBase.post(this.route, payload).then(({ data }) => data);
  }

  public static startReport(payload: ITimeReport): Promise<createTimeReportResponse> {
    return axiosBase.post(`${this.route}/start`, payload).then(({ data }) => data);
  }

  public static update(payload: Partial<ITimeReport>): Promise<createTimeReportResponse> {
    const { _id, ...data } = payload;
    return axiosBase.patch(`${this.route}/${payload._id}`, data).then(({ data }) => data);
  }

  public static delete(timeReportId: string): Promise<void> {
    return axiosBase.delete(`${this.route}/${timeReportId}`);
  }
}
